import { createReducer, on } from "@ngrx/store";
import { updateState } from "@obg/ngx.global";

import { ImageAction } from "./image.action";
import { ImageDictionary, ImagesPayload, ImageState } from "./image.model";

const initialState: ImageState = {
	isBusy: false,
	images: {},
};

export const imageReducer = createReducer(
	initialState,
	on(
		ImageAction.getAll,
		(state): ImageState =>
			updateState(state, {
				isBusy: true,
			})
	),
	on(ImageAction.getAllSuccess, (state, { payload }: { payload: ImagesPayload }): ImageState => {
		const { icons, flags, ...images } = payload.images;
		const newImages = {
			images: images as ImageDictionary,
			icons: icons as ImageDictionary,
			flags: flags as ImageDictionary,
		};

		return updateState(state, {
			images: updateState(state.images, {
				[payload.group]: newImages,
			}),
			isBusy: false,
		});
	}),
	on(
		ImageAction.getAllFail,
		(state): ImageState =>
			updateState(state, {
				isBusy: false,
			})
	),
	on(ImageAction.setImages, (state, { payload }: { payload: ImagesPayload }): ImageState => {
		const { icons, flags, ...images } = payload.images;
		const newImages = {
			images: images as ImageDictionary,
			icons: icons as ImageDictionary,
			flags: flags as ImageDictionary,
		};

		return updateState(state, {
			images: updateState(state.images, {
				[payload.group]: newImages,
			}),
		});
	})
);
